module.exports = __webpack_public_path__ + "img/cooper_run.a8e2c798.svg";